/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
const refreshConstants = {
  REFRESH_DATA: 'REFRESH_DATA',
  WHENS: 'WHENS',
  DECLARE_EXPRESSIONS: 'DECLARE_EXPRESSIONS',
  REFRESH: 'refresh',
  REFRESH_CASE_DATA: 'refreshCaseData',
  REFRESH_ASSIGNMENT_DATA: 'refreshAssignmentData',
  REFRESH_CASE_VIEW: 'refreshCaseView',
  RECALCULATE: 'recalculate',
  RECALCULATE_CASE_DATA: 'recalculateCaseData',
  RECALCULATE_ASSIGNMENT_DATA: 'recalculateAssignmentData',
  REFRESH_EXTERNAL_OBJECT: 'refreshExternalObjectData'
};
export default refreshConstants;
